import styled from 'styled-components';

export const PageContent = styled.div`
    flex-grow:1;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
`;
